const startButton = document.getElementById("start-btn");
const nextButton = document.getElementById("next-btn");
const showMeButton = document.getElementById("show-me-how-btn");
const questionContainerElement = document.getElementById("question23-container");
const questionElement = document.getElementById("question23");
const answerButtonsElement = document.getElementById("answer-buttons23");
const ctaElement = document.getElementById("cta23");


const questions23 = [
  {
    question:
      "What kind of team do you have?",
    answers: [
      { text: "Sales", correct: true },
      { text: "Customer Service", correct: true },
    ],
  },
  {
    question: "How long is your training program?",
    answers: [
      { text: "Under a week", correct: true },
      { text: "1 Week", correct: true },
      { text: "2-3 Weeks", correct: true },
      { text: "3+ Weeks", correct: true },
    ],
  },
  {
    question: "How often do they answer client or prospect questions successfully?",
    answers: [
      { text: "Most of the time", correct: true },
      { text: "I don’t know", correct: true },
      { text: "Sometimes", correct: true },
    ],
  },
];


let shuffledQuestions23, currentQuestionIndex23;

startButton.addEventListener("click", startQuiz);
nextButton.addEventListener("click", () => {
  currentQuestionIndex23++;
  setNextQuestion();
  rotateGallery();
});

function startQuiz() {
  startButton.classList.add("hide");
  shuffledQuestions23 = questions23.sort();
  // () => Math.random() - 0.5;
  currentQuestionIndex23 = 0;
  questionContainerElement.classList.remove("hide");
  setNextQuestion();
}

function setNextQuestion() {
  resetState();
  if(currentQuestionIndex23 > questions23.length - 1){
    displaySuccess();
    return
  } 
  showQuestion(shuffledQuestions23[currentQuestionIndex23]);
}

function displaySuccess(){
  ctaElement.innerText =
  "Fantastic! DYL’s Call Whispering feature is accompanied by unlimited call recording and activity reports, so management can see if an employee is accurately answering a client’s or prospect’s questions. They can also take advantage of the whisper function to train Sales staff, putting them one step closer to the sale.";
  questionContainerElement.classList.add("hide");
  ctaElement.classList.remove("hide");
  showMeButton.classList.remove("hide");
}

function showQuestion(question) {
  questionElement.innerText = question.question;
  question.answers.forEach((answer) => {
    const button = document.createElement("h5");
    button.innerText = answer.text;
    button.classList.add("btn-block");
    button.classList.add("btn-primary");
    button.classList.add("p-2");
    button.classList.add("transition-3d-hover");
    button.classList.add("text-center");
    if (answer.correct) {
      button.dataset.correct = answer.correct;
    }
    button.addEventListener("click", selectAnswer);
    answerButtonsElement.appendChild(button);
  });
}

function resetState() {
  clearStatusClass(document.body);
  nextButton.classList.add("hide");
  while (answerButtonsElement.firstChild) {
    answerButtonsElement.removeChild(answerButtonsElement.firstChild);
  }
}

function selectAnswer(e) {
  const selectedButton = e.target;
  const correct = selectedButton.dataset.correct;
  setStatusClass(document.body, correct);
  Array.from(answerButtonsElement.children).forEach((button) => {
    setStatusClass(button, button.dataset.correct);
    selectedButton.style.backgroundColor = "green";
  });
    nextButton.classList.remove("hide");
}


function setStatusClass(element, correct) {
  clearStatusClass(element);
  if (correct) {
    element.classList.add("correct");
  } else {
    element.classList.add("wrong");
  }
}

function clearStatusClass(element) {
  element.classList.remove("correct");
  element.classList.remove("wrong");
}

let counter = 0,
  gallery = [
    "https://images.dyl.com/marketing-web/images/quiz/man-jogging-through-forest-path.jpg",
    "https://images.dyl.com/marketing-web/images/quiz/woman-pondering-in-thought.jpg",
    "https://images.dyl.com/marketing-web/images/quiz/woman-smiling-excited-with-yellow-background.jpg",
  ];
function rotateGallery() {
  document.getElementById("ImgGalleryCWQ").src = gallery[counter];
  counter++;
  if (counter >= gallery.length) {
    counter = 0;
  }
}

